import React, { useEffect } from "react";
import { NavWrap } from "../ShopForTyres";
import "./dashboard.css";
import file from "../../assets/file.svg";
import PendingActions from "./PendingActions";
import UpcomingPayments from "./UpcomingPayments";
import { useDispatch, useSelector } from "react-redux";
import { get_addresses, get_regions } from "../../actions/orders";
import { useHistory } from "react-router-dom";
// import { get_dashboard } from "../../actions/auth/Action";

const OverviewTab = ({ isShipment }) => {
  const dashboard = useSelector(
    (state) => state?.auth?.dashboard?.data?.dash_borad?.[0]
  );
  return (
    <div className="overview-tab">
      <div className="d-flex">
        <div className="activity">
          <span>
            <img src={file} width={30} alt="file" />
          </span>
          <span className="title">
            {isShipment ? "Shipment Activity" : "Orders Activity"}
          </span>
        </div>
        {isShipment ? (
          <div className="contents w70">
            <div>
              <label>Planned</label>
              <span>{dashboard?.["OpenDelivery"]}</span>
            </div>
            <div>
              <label>In-Transit</label>
              <span>-</span>
            </div>
            <div>
              <label>Completed</label>
              <span>{dashboard?.["CompletedDelivery"]}</span>
            </div>
          </div>
        ) : (
          <div className="contents w80">
            <div>
              <label>Awaiting</label>
              <span>{dashboard?.["OpenQuotation"]}</span>
            </div>
            <div>
              <label>Confirmed</label>
              <span>{dashboard?.["CompletedQuotation"]}</span>
            </div>
            <div>
              <label>Completed</label>
              <span>{dashboard?.["CompletedSales"]}</span>
            </div>
            <div>
              <label>Cancelled</label>
              <span>-</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const Dashboard = () => {
  const dispatch = useDispatch();
  const address = useSelector((state) => state?.orders?.addresses?.data?.[0]);
  const history = useHistory();
  useEffect(() => {
    let obj = {
      email: localStorage.getItem("email"),
    };
    dispatch(get_regions(obj));
    dispatch(get_addresses(obj));
    // eslint-disable-next-line
  }, []);
  return (
    <NavWrap>
      <div className="cart dashboard">
        <div className="head-sec">
          <div>
            <label>Overview</label>
          </div>
          <div>{/* <label>Last 30 Days</label> */}</div>
        </div>
        <div className="ot1">
          <OverviewTab />
        </div>
        <div className="ot2">
          <OverviewTab isShipment={true} />
        </div>
        <div className="dash-details">
          <div className="dashImg">
            <div>
              <h3>ORDER YOUR TYRES RIGHT FROM THE DASHBOARD</h3>
              <p>View our wide range of brands covering multiple segments</p>
            </div>
            <div className="btns">
              <button
                className="primary-btn"
                onClick={() => {
                  history.push("/admin/shop-for-tyres");
                }}
              >
                Place an Order
              </button>
              <button className="white-btn">Track Shipments</button>
            </div>
          </div>
          <div className="details">
            <div className="box">
              <span className="img"></span>
              <div>
                <span>Name</span>
                <span>{localStorage.getItem("email")}</span>
              </div>
              <div>
                <span>Shipping Address</span>
                <span>
                  {address?.address1}, {address?.city}, {address?.zip}
                </span>
              </div>
              <span className="link">View more details</span>
            </div>
            <div className="box">
              <div className="rewards">
                <span>Rewards</span>
                <span>
                  Get a complete overview of the orders, shipments on the OMNI
                  distributor Dashboard.
                </span>
              </div>
              <div className="flex-between">
                <span className="link">View more details</span>
                <span className="img mr1"></span>
              </div>
            </div>
          </div>
        </div>
        <PendingActions />
        <UpcomingPayments />
      </div>
    </NavWrap>
  );
};

export default Dashboard;
